export default "/images/no-result.png";